export function TaskListIcon() {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 2.16663L2.25 3.41663L4.75 0.916626M4.75 7.99996L6 9.24996L8.5 6.74996M1 13.8333L2.25 15.0833L4.75 12.5833M11.4167 7.99996H20.5833H11.4167ZM7.66667 13.8333H16.8333H7.66667ZM7.66667 2.16663H16.8333H7.66667Z"
        fill="#C968C5"
      />
      <path
        d="M1 2.16663L2.25 3.41663L4.75 0.916626M4.75 7.99996L6 9.24996L8.5 6.74996M1 13.8333L2.25 15.0833L4.75 12.5833M11.4167 7.99996H20.5833M7.66667 13.8333H16.8333M7.66667 2.16663H16.8333"
        stroke="#DFDFDF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
